import { useImports } from 'app/components/imports/useImports'
import { ImportsComponent } from 'app/components/imports/ImportsComponent'

export const handler = {
  title: `Import`,
  breadcrumb: `Import`,
}

export default function Import(): React.ReactElement {
  const hookData = useImports()
  return <ImportsComponent {...hookData} />
}
